import AddOiGroupWizard from './AddOiGroupWizardContainer';
export default AddOiGroupWizard;
